var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-admin-page',{scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('ades-management')]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }